'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><g clipPath="url(#forum_svg__a)"><path fill="currentColor" fillRule="evenodd" d="M.333 16a2 2 0 0 0 3.404 1.424l2.916-2.874h8.68a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4h-11a4 4 0 0 0-4 4zm15-3.45h-9.5L2.333 16V4a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v6.55a2 2 0 0 1-2 2m-10-8.05a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zm-1 4.5a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1m4.036 8.236C7.897 16.715 8.363 16 9.066 16h.49c.257 0 .497.108.714.244a2 2 0 0 0 1.063.305h7.5l3.5 3.45V9c0-.638-.3-1.207-.765-1.573-.382-.3-.735-.703-.735-1.19 0-.64.573-1.144 1.156-.878a4 4 0 0 1 2.344 3.641v11a2 2 0 0 1-3.404 1.425l-2.916-2.875h-6.68a4 4 0 0 1-2.964-1.313" clipRule="evenodd" /></g><defs><clipPath id="forum_svg__a"><path fill="#fff" d="M0 0h24v24H0z" /></clipPath></defs></svg>;
const IconForum = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconForum;